export type CustomTranslations<T extends string> = {
  [key in T]: {
    [key: string]: string;
  };
};

export function createLocalizedProxy<
  T extends { customTranslations: CustomTranslations<TranslatableAttributes> },
  TranslatableAttributes extends string,
>(section: T, translatableAttributeMapping: Record<string, string>, locale: string): T {
  const proxy = {
    get(target: T, prop: string | symbol, _receiver: unknown): unknown {
      if (Object.hasOwn(translatableAttributeMapping, prop)) {
        const mappedProp = <TranslatableAttributes>translatableAttributeMapping[<string>prop]!;
        const value = target.customTranslations?.[mappedProp]?.[locale];
        if (value) return value;
        // If we didn't have a selected-locale-specific version of this attribute, fall back to the default locale.
      }
      return target[<keyof T>prop];
    },
  };

  return new Proxy(section, proxy);
}
